export default __webpack_public_path__ + "static/econsans-primary-subset-bd-44e5cdc8d467cdb420df67f49771d5e1.woff";